import { render, staticRenderFns } from "./popup-upload-snapshots.vue?vue&type=template&id=71522852&scoped=true"
import script from "./popup-upload-snapshots.vue?vue&type=script&lang=js"
export * from "./popup-upload-snapshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71522852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71522852')) {
      api.createRecord('71522852', component.options)
    } else {
      api.reload('71522852', component.options)
    }
    module.hot.accept("./popup-upload-snapshots.vue?vue&type=template&id=71522852&scoped=true", function () {
      api.rerender('71522852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/views/find-user/popups/popup-upload-snapshots.vue"
export default component.exports